/**
 * Created by USER on 18/5/17.
 */
import React, { Component } from 'react';

export default class SingleTheme extends Component {
  render() {
    const {themeTitle, themeDetails, img, icon} = this.props;
    return (
      <div
        className="sinle_advantage_block"
      >
        <img src={img} alt="lubanso" />
        <div>
          <div className="single_advantage_head_icon"><i className={`icon iconfont ${icon}`} /></div>
          <p className="single_advantage_theme">{themeTitle}</p>
          {
            themeDetails.map((item) => (
              <div className="single_advantage_details" key={item.index}>{item}</div>
            ))
          }
        </div>
      </div>
    );
  }
}
